import { useMarket, useT } from "../../i18n";
import { useUnitSystem } from "../../units/UnitSystemContext";
import "./unit-system-toggle.css";

/**
 * Metric <-> imperial segmented control. Rendered only on the intl market —
 * the se market is always metric. The preference is device-local (see
 * UnitSystemContext) and drives display formatting only; all storage and
 * calculation stay metric.
 */
export function UnitSystemToggle() {
	const market = useMarket();
	const t = useT();
	const { unitSystem, setUnitSystem } = useUnitSystem();

	if (market !== "intl") return null;

	return (
		// biome-ignore lint/a11y/useSemanticElements: compact segmented toggle — a <fieldset> would force legend/border styling; role="group" + aria-label is intended (cf. MaterialPane).
		<div className="unit-toggle" role="group" aria-label={t.units_ariaLabel}>
			<span className="unit-toggle__label">{t.units_label}</span>
			<div className="unit-toggle__options">
				<button
					type="button"
					className={`unit-toggle__btn${unitSystem === "metric" ? " unit-toggle__btn--active" : ""}`}
					aria-pressed={unitSystem === "metric"}
					onClick={() => setUnitSystem("metric")}
				>
					{t.units_metric}
				</button>
				<button
					type="button"
					className={`unit-toggle__btn${unitSystem === "imperial" ? " unit-toggle__btn--active" : ""}`}
					aria-pressed={unitSystem === "imperial"}
					onClick={() => setUnitSystem("imperial")}
				>
					{t.units_imperial}
				</button>
			</div>
		</div>
	);
}
